import { ValueOf } from "src/types.d"

export const ContactAttendanceAnswerScreens = Object.freeze({
  ContactAttendanceAnswerOverview: "ContactAttendanceAnswerOverview",
  ContactAttendanceAnswerDetail: "ContactAttendanceAnswerDetail",
} as const)

export type ContactAttendanceAnswerScreens = ValueOf<typeof ContactAttendanceAnswerScreens>
